import { useState } from 'react'
import { Header } from './Header.js'
import { Footer } from './Footer.js'

import './Contact.css'

export function Contact () {
  const [showThanks, setShowThanks] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })

  function handleChange (evt) {
    setFormData({
      ...formData,
      [evt.target.name]: evt.target.value
    })
  }

  async function handleSubmit (e) {
    e.preventDefault()

    await fetch('https://api.fernandfablepicnics.com/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })

    setShowThanks(true)
  }

  return (
    <div>
      <Header activeItem='contact' />
      <main>
        <section className='contact-section'>
          <div className='container'>
            <h1>Contact Us</h1>
            <div className='contact-grid'>
              <div className='contact-form'>
                <form onSubmit={handleSubmit}>
                  <div className='form-group'>
                    <label htmlFor='name'>Name</label>
                    <input
                      type='text'
                      id='name'
                      name='name'
                      required
                      onChange={handleChange}
                      value={formData.name}
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='email'>Email</label>
                    <input
                      type='email'
                      id='email'
                      name='email'
                      required
                      onChange={handleChange}
                      value={formData.email}
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='message'>Message</label>
                    <textarea
                      id='message'
                      name='message'
                      required
                      onChange={handleChange}
                      value={formData.message}
                    ></textarea>
                  </div>
                  <button type='submit' className='button'>
                    Send Message
                  </button>
                  {showThanks && (
                    <div className='confirmation'>
                      Thanks for contacting us! We'll get back to you as soon as
                      possible.
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
